import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import Create from "../../components/SupportTicketCreate";
import { useAuth } from "../../context/AuthContext";
import Toaster from "../../components/ui/toaster";

export default function SupportEmail() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  return (
    <>
      <Header />
      <div className="min-h-screen w-full flex flex-col overflow-y-auto bg-[#F8F8F8]">
        <div className="h-[72px] bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] lg:flex items-center pl-20 text-white hidden">
          <div className="mr-5 border-rounded rounded-full p-2.5 border">
            <ArrowLeft
              size={18}
              onClick={() => {
                navigate("/support/index");
              }}
            />
          </div>
          <p className="text-[16px] font-semibold">
            Support <span className="mx-2 font-normal">/</span>{" "}
            <span>Get in touch</span>
          </p>
        </div>

        <Create
          onCreateSuccess={() => {}}
          userId={userProfile?._id}
          onDone={() => navigate("/support/index")}
        />
      </div>
      <Toaster />
    </>
  );
}
